import { twMerge } from 'tailwind-merge';

const IconWrapper = ({ children, className }) => (
    <div className={twMerge('bg-theme1-gold p-2 rounded-xl w-10 h-10 flex items-center justify-center', className)}>
        {children}
    </div>
);

export default IconWrapper;
